/**
 * PerplayAdminApi
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';

/**
 * The AccountControllerDtoAccountInventoryInfoAccountInventorySpecialBox model module.
 * @module model/AccountControllerDtoAccountInventoryInfoAccountInventorySpecialBox
 * @version 1.0
 */
class AccountControllerDtoAccountInventoryInfoAccountInventorySpecialBox {
    /**
     * Constructs a new <code>AccountControllerDtoAccountInventoryInfoAccountInventorySpecialBox</code>.
     * @alias module:model/AccountControllerDtoAccountInventoryInfoAccountInventorySpecialBox
     */
    constructor() { 
        
        AccountControllerDtoAccountInventoryInfoAccountInventorySpecialBox.initialize(this);
    }

    /**
     * Initializes the fields of this object.
     * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
     * Only for internal use.
     */
    static initialize(obj) { 
    }

    /**
     * Constructs a <code>AccountControllerDtoAccountInventoryInfoAccountInventorySpecialBox</code> from a plain JavaScript object, optionally creating a new instance.
     * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @param {module:model/AccountControllerDtoAccountInventoryInfoAccountInventorySpecialBox} obj Optional instance to populate.
     * @return {module:model/AccountControllerDtoAccountInventoryInfoAccountInventorySpecialBox} The populated <code>AccountControllerDtoAccountInventoryInfoAccountInventorySpecialBox</code> instance.
     */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new AccountControllerDtoAccountInventoryInfoAccountInventorySpecialBox();

            if (data.hasOwnProperty('specialBoxNo')) {
                obj['specialBoxNo'] = ApiClient.convertToType(data['specialBoxNo'], 'Number');
            }
            if (data.hasOwnProperty('boxLevel')) {
                obj['boxLevel'] = ApiClient.convertToType(data['boxLevel'], 'Number');
            }
            if (data.hasOwnProperty('createdAt')) {
                obj['createdAt'] = ApiClient.convertToType(data['createdAt'], 'Date');
            }
            if (data.hasOwnProperty('maturedAt')) {
                obj['maturedAt'] = ApiClient.convertToType(data['maturedAt'], 'Date');
            }
        }
        return obj;
    }

    /**
     * Validates the JSON data with respect to <code>AccountControllerDtoAccountInventoryInfoAccountInventorySpecialBox</code>.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @return {boolean} to indicate whether the JSON data is valid with respect to <code>AccountControllerDtoAccountInventoryInfoAccountInventorySpecialBox</code>.
     */
    static validateJSON(data) {

        return true;
    }


}



/**
 * @member {Number} specialBoxNo
 */
AccountControllerDtoAccountInventoryInfoAccountInventorySpecialBox.prototype['specialBoxNo'] = undefined;

/**
 * @member {Number} boxLevel
 */
AccountControllerDtoAccountInventoryInfoAccountInventorySpecialBox.prototype['boxLevel'] = undefined;

/**
 * @member {Date} createdAt
 */
AccountControllerDtoAccountInventoryInfoAccountInventorySpecialBox.prototype['createdAt'] = undefined;

/**
 * @member {Date} maturedAt
 */
AccountControllerDtoAccountInventoryInfoAccountInventorySpecialBox.prototype['maturedAt'] = undefined;






export default AccountControllerDtoAccountInventoryInfoAccountInventorySpecialBox;

